var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"drawerShow":false}},[_c('template',{slot:"nav"}),_c('template',{slot:"nav-tools"}),_c('template',{slot:"drawer"}),_c('template',{slot:"content"},[_c('v-container',{attrs:{"fluid":""}},[_c('bookings-list-table',{ref:"bookingListTable"})],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }